import { render } from "./MessageItemMoreMenu.vue?vue&type=template&id=f922e83e&scoped=true"
import script from "./MessageItemMoreMenu.vue?vue&type=script&lang=js"
export * from "./MessageItemMoreMenu.vue?vue&type=script&lang=js"

import "./MessageItemMoreMenu.vue?vue&type=style&index=0&id=f922e83e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f922e83e"]])

export default __exports__